import * as ActionTypes from './actionTypes';

const initialState = {
  finances: null,
  financesLoading: true,
  financeOverview: null,
  financeOverviewLoading: true,
};

export default function finance(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.GET_FINANCES:
      return {
        ...state,
        financesLoading: true,
      };

    case ActionTypes.GET_FINANCES_SUCCESS:
      return {
        ...state,
        financesLoading: false,
        finances: action.payload,
      };

    case ActionTypes.GET_FINANCES_FAILED:
      return {
        ...state,
        financesLoading: false,
      };

    case ActionTypes.GET_FINANCE_OVERVIEW:
      return {
        ...state,
        financeOverviewLoading: true,
      };

    case ActionTypes.GET_FINANCE_OVERVIEW_SUCCESS:
      return {
        ...state,
        financeOverviewLoading: false,
        financeOverview: action.payload,
      };

    case ActionTypes.GET_FINANCE_OVERVIEW_FAILED:
      return {
        ...state,
        financeOverviewLoading: false,
      };
    default:
      return state;
  }
}
